module.exports = __webpack_public_path__ + "media/stylesheets/images/kurashino_logo-20c56e7cc2e71ba8776cc5ce638eb117.svg";